import script from "./CalcAd.vue?vue&type=script&setup=true&lang=js"
export * from "./CalcAd.vue?vue&type=script&setup=true&lang=js"

import "./CalcAd.vue?vue&type=style&index=0&id=4d823d18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d823d18"]])

export default __exports__